<template>
  <div class="clientone">
    <p class="ma-10">Function of "Assign Card" will be added later.</p>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: "clientone",
  components: {}
};
</script>
